<template>
  <v-container class="pa-0" fluid="fluid" grid-list-md="grid-list-md">
    <v-row>
      <v-col cols="12">
        <h3 class="text-center font-weight-light mb-2">THÔNG TIN TỔNG QUAN</h3>
      </v-col>
    </v-row>
    <v-row justify="center" class="mt-2">
      <v-col cols="12" md="3">
        <v-card to="/admin/product-chains" outlined elevation="2" class="rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              <div>Sản phẩm chuỗi</div>
              <p class="text-h4 text--primary">
                <v-progress-circular
                  v-if="chainCountLoading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ chainCount }}</span>
              </p>
            </v-card-text>
            <v-avatar
              class="ma-3"
              size="80"
              tile
            >
              <v-img src="@/assets/home/icon_v2/ProductChain.png"/>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" md="3">
        <v-card to="/admin/market-prices" outlined elevation="2" class="rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              <div>Giá thị trường</div>
              <p class="text-h4 text--primary">
                <v-progress-circular
                  v-if="marketCountLoading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ marketCount }}</span>
              </p>
            </v-card-text>
            <v-avatar
              class="ma-3"
              size="80"
              tile
            >
              <v-img src="@/assets/home/icon_v2/MarketPrice.png"/>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="$role('ql-chat-luong')" cols="12" md="3">
        <v-card outlined elevation="2" class="rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              <div>Lượt xem</div>
              <p class="text-h4 text--primary">
                <v-progress-circular
                  v-if="marketViewCountLoading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ marketViewCount }}</span>
              </p>
            </v-card-text>
            <v-avatar
              class="ma-3"
              size="80"
              tile
            >
              <v-img src="@/assets/home/icon_v2/View.png"/>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="$role('ql-chat-luong')" cols="12" md="3">
        <v-card outlined elevation="2" class="rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              <div>Lượt tải về</div>
              <p class="text-h4 text--primary">
                <v-progress-circular
                  v-if="marketDownCountLoading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ marketDownCount }}</span>
              </p>
            </v-card-text>
            <v-avatar
              class="ma-3"
              size="80"
              tile
            >
              <v-img src="@/assets/home/icon_v2/Download.png"/>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="!$role('ql-chat-luong')" cols="12" md="3">
        <v-card to="/admin/contacts" outlined elevation="2" class="rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              <div>Liên hệ, phản hồi</div>
              <p class="text-h4 text--primary">
                <v-progress-circular
                  v-if="contactCountLoading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ contactCount }}</span>
              </p>
            </v-card-text>
            <v-avatar
              class="ma-3"
              size="80"
              tile
            >
              <v-img src="@/assets/home/icon_v2/Contact.png"/>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
      <v-col v-if="!$role('ql-chat-luong')" cols="12" md="3">
        <v-card to="/admin/supports" outlined elevation="2" class="rounded-lg">
          <div class="d-flex flex-no-wrap justify-space-between">
            <v-card-text>
              <div>Hỏi đáp kỹ thuật</div>
              <p class="text-h4 text--primary">
                <v-progress-circular
                  v-if="qasCountLoading"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
                <span v-else>{{ qasCount }}</span>
              </p>
            </v-card-text>
            <v-avatar
              class="ma-3"
              size="80"
              tile
            >
              <v-img src="@/assets/home/icon_v2/Fap.png"/>
            </v-avatar>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="$can('tong-quan-xem')">
      <v-col 
        cols="12" 
        sm="12" 
        md="6"
      >
        <v-card 
          outlined 
          class="mx-auto rounded-lg"
        >
          <v-card-title class="primary--text">
            <span class="font-weight-light" style="font-size: 16px;">
              Liên hệ gần đây
            </span>
          </v-card-title>
          <v-card-text
            style="height: 250px;"
          >
            <v-skeleton-loader
              v-if="contactLoading"
              type="list-item-three-line, list-item-three-line, card-heading"
            />
            <v-simple-table
              v-else
              fixed-header
              height="250px"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Tiêu đề</th>
                    <th>Tên</th>
                    <th>Thời gian</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="contact in contactRecent"
                    :key="contact.id"
                  >
                    <td>{{ contact.title }}</td>
                    <td>{{ contact.name }}</td>
                    <td>{{ contact.created_at_text }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col 
        cols="12" 
        sm="12" 
        md="6"
      >
        <v-card 
          outlined 
          class="mx-auto rounded-lg"
        >
          <v-card-title class="primary--text">
            <span class="font-weight-light" style="font-size: 16px;">
              Hỏi-đáp gần đây
            </span>
          </v-card-title>
          <v-card-text
            style="height: 250px;"
          >
            <v-skeleton-loader
              v-if="qasLoading"
              type="list-item-three-line, list-item-three-line, card-heading"
            />
            <v-simple-table
              v-else
              fixed-header
              height="250px"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>Tiêu đề</th>
                    <th>Lĩnh vực</th>
                    <th>Thời gian</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="qas in qasRecent"
                    :key="qas.id"
                  >
                    <td>{{ qas.tieude }}</td>
                    <td>{{ qas.branch.name }}</td>
                    <td>{{ qas.created_at_text }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="$can('tong-quan-xem')">
      <v-col 
        cols="12" 
        sm="12" 
        md="6"
      >
        <v-card 
          outlined 
          class="mx-auto rounded-lg"
        >
          <v-card-title class="primary--text">
            <span class="font-weight-light" style="font-size: 16px;">
              Hỏi-đáp theo lĩnh vực
            </span>
          </v-card-title>
          <v-card-text style="height: 250px;" id="hoi-dap-by-lv">
            <SupportByBranchDoughnut 
              :chart-data="doughnutData" 
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col 
        cols="12" 
        sm="12" 
        md="6"
      >
        <v-card 
          outlined 
          class="mx-auto rounded-lg"
        >
          <v-card-title class="primary--text">
            <span class="font-weight-light" style="font-size: 16px;">
              Hỏi-đáp theo trạng thái
            </span>
          </v-card-title>
          <v-card-text style="height: 250px;" id="hoi-dap-by-lv">
            <SupportByStatusPie
              :chart-data="doughnutData" 
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="$can('tong-quan-xem')">
      <v-col 
        cols="12" 
        sm="12" 
        md="6"
      >
        <v-card 
          outlined 
          class="mx-auto rounded-lg"
        >
          <v-card-title class="primary--text">
            <span class="font-weight-light" style="font-size: 16px;">
              Thao tác gần đây
            </span>
            <v-spacer/>
            <v-chip
              color="primary"
              dark
              to="/admin/activity-logs"
            >
              <span class="caption">
                Xem tất cả
              </span>
            </v-chip>
          </v-card-title>
          <v-card-text
            style="height: 304px;"
          >
            <v-skeleton-loader
              v-if="actLoading"
              type="list-item-three-line, list-item-three-line, card-heading"
            />
            <v-simple-table
              v-else
              fixed-header
              height="300px"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Subject</th>
                    <th>Thời gian</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="act in activities"
                    :key="act.id"
                  >
                    <td>{{ act.user ? act.user.name : 'Unknown' }}</td>
                    <td>{{ act.subject }}</td>
                    <td>{{ act.created_at }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col 
        cols="12" 
        sm="12" 
        md="6"
      >
        <v-card outlined class="mx-auto text-center rounded-lg">
          <v-card-title class="primary--text">
            <span class="font-weight-light" style="font-size: 16px;">
              Thống kê truy cập
            </span>
            <v-spacer/>
            <v-select
              v-model="yearSelected"
              :items="years"
              item-text="value"
              dense
              single-line
              label="Năm"
              class="shrink year-filter"
              hide-details
              return-object
            >
              <template v-slot:selection="{ item }">
                <span class="d-flex justify-center" style="width: 100%;">
                  {{ item.value }}
                </span>
              </template>
          </v-select>
          </v-card-title>
          <v-card-text
            style="height: 300px; position: relative;"
          >
            <v-skeleton-loader
              v-if="thongKeLoading"
              type="list-item-three-line, card-heading"
            />
            <AccessBarChart 
              v-if="yearSelected"
              :chart-data="doughnutData" 
              :year="String(yearSelected.value)"
              :height="1" 
              :width="2"
              @finish="onFinishRender" 
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>  
  </v-container>
</template>
<script>
  import DashMap from '@/components/admin/dashboard/Map';
  import AccessBarChart from '@/components/admin/dashboard/AccessBarChart';
  import SupportByBranchDoughnut from '@/components/admin/dashboard/SupportByBranchDoughnut';
  import SupportByStatusPie from '@/components/admin/dashboard/SupportByStatusPie';
  export default {
    components: {
      DashMap,
      AccessBarChart,
      SupportByBranchDoughnut,
      SupportByStatusPie
    },
    data: () => ({
      actLoading: false,
      thongKeLoading: true,
      activities: [],
      qasCount: 0,
      qasCountLoading: false,
      contactCount: 0,
      contactCountLoading: false,
      marketCount: 0,
      marketCountLoading: false,
      chainCount: 0,
      chainCountLoading: false,
      marketViewCount: 0,
      marketViewCountLoading: false,
      marketDownCount: 0,
      marketDownCountLoading: false,
      qasRecent: [],
      contactRecent: [],
      qasLoading: false,
      contactLoading: false,
      doughnutData: {},
      years: [],
      yearSelected: {},
    }),
    mounted() {
      this.getMarketCount();
      this.getChainCount();
      this.getMarketViewCount();
      this.getMarketDownCount();
      if(!this.$role('ql-chat-luong')){
        this.getRecentActivities();
        this.getQasCount();
        this.getContactCount();
        this.getRecentQas();
        this.getRecentContact();
        this.getAllNamFromSiteView();
      }
    },
    methods: {
      getQasCount(){
        this.qasCountLoading = true;
        axios.get("api/v1/supports-count")
          .then(response => {
            this.qasCount = response.data;
            this.qasCountLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getContactCount(){
        this.contactCountLoading = true;
        axios.get("api/v1/contacts-count-all")
          .then(response => {
            this.contactCount = response.data;
            this.contactCountLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getMarketCount(){
        this.marketCountLoading = true;
        axios.get("api/v1/market-prices-count")
          .then(response => {
            this.marketCount = response.data;
            this.marketCountLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getChainCount(){
        this.chainCountLoading = true;
        axios.get("api/v1/product-chains-count")
          .then(response => {
            this.chainCount = response.data;
            this.chainCountLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getRecentActivities(){
        this.actLoading=true;
        axios.get("api/v1/recent-activities")
          .then(response => {
            this.activities = response.data;
            this.actLoading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getRecentQas(){
        this.qasLoading=true
        axios.get("api/v1/recent-qas")
          .then(response => {
            this.qasRecent = response.data;
            this.qasLoading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getRecentContact(){
        this.contactLoading=true;
        axios.get("api/v1/contact-recent")
          .then(response => {
            this.contactRecent = response.data;
            this.contactLoading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getAllNamFromSiteView(){
        axios.get("api/v1/get-all-year-from-siteview")
          .then(response => {
            this.years = response.data;
            const currentYear = (new Date()).getFullYear();
            this.yearSelected = response.data.find(obj => obj.value == currentYear);
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getMarketViewCount(){
        this.marketViewCountLoading = true;
        axios.get("api/v1/market-view-count")
          .then(response => {
            this.marketViewCount = response.data;
            this.marketViewCountLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getMarketDownCount(){
        this.marketDownCountLoading = true;
        axios.get("api/v1/market-down-count")
          .then(response => {
            this.marketDownCount = response.data;
            this.marketDownCountLoading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      onFinishRender() {
        this.thongKeLoading = false;
      },
    }
  }
</script>
<style scoped>
  #hoi-dap-by-lv div{
    height: 200px;
  }
  .year-filter{
    width: 100px !important;
  }
</style>
